<ecp-loader style="opacity: 0.5;" *ngIf="!(frame$ | async) || orderFrameLoading"></ecp-loader>
<div class="row" *ngIf="frame$ | async">
  <div class="col s12 l8">
    <div class="container">
      <ecp-order-breadcrumbs></ecp-order-breadcrumbs>
      <!-- Frame -->
      <div class="row">
        <mat-card class="mat-card--widget">
          <mat-card-content>
            <!--             <div class="container">
              <div class="row mt-20">
                <div class="col s12 text-align-right" *ngIf="patientId">
                  <ecp-add-to-cart-btn
                    *ngIf="frame?.collectionContext === 'InModule'"
                    [patientId]="patientId"
                    [frameDetail]="frame"
                  ></ecp-add-to-cart-btn>
                </div>
              </div>
            </div> -->
            <div class="container">
              <div class="col s5">
                <img
                  class="frame__image"
                  src="{{ frame?.largeImageUrl }}"
                  onError="this.src='/assets/images/frame-default-lg.png'"
                />
              </div>
              <div class="col s7">
                <div>
                  <h2>{{ frame?.collectionName }} {{ frame?.styleName }}</h2>
                  <p>{{ frame?.colorDescription }}</p>
                  <p>{{ frame?.upc }}</p>
                  <p>{{ frame?.moduleName }}</p>
                </div>
                <div *ngIf="frame$ | async">
                  <p *ngIf="frame?.exceptionType == 'NOT_IN_PROGRAM'" class="brand-color">Discontinued</p>
                  <p *ngIf="frame?.exceptionType == 'NOT_IN_PROGRAM'" style="margin-bottom:10px;" class="brand-color">
                    This frame has been discontinued by the manufacturer. If you are attempting to place a complete job
                    (Frame + Rx) please contact your Customer Service to make arrangements to send in the frame from
                    your board.
                  </p>
                  <p
                    *ngIf="
                      (frame?.statusCode == 'L_ACTIVE' &&
                        frame?.exceptionType == 'OUT_OF_STOCK' &&
                        frame?.inStock == false) ||
                      (frame?.exceptionType == 'SHORT_SHIP' && frame?.inStock == false)
                    "
                    class="out-of-stock-class"
                  >
                    Out of Stock
                  </p>
                  <p
                    *ngIf="
                      (frame?.statusCode == 'L_ACTIVE' &&
                        frame?.exceptionType == 'OUT_OF_STOCK' &&
                        frame?.inStock == false) ||
                      (frame?.exceptionType == 'SHORT_SHIP' && frame?.inStock == false)
                    "
                    class="out-of-stock-class"
                  >
                    This frame is out of stock for an extended period of time.<br />If you are attempting to place a
                    Complete job (Frame + Rx), please contact your customer service to make arrangements to send in the
                    frame from your board. To replace the frame from your board, please place a Frame Only order for
                    your office, which we will fulfill as soon as this frame is available again.
                  </p>
                  <p *ngIf="frame?.statusCode == 'L_WARRANTY'" style="margin-bottom:10px;" class="out-of-stock-class">
                    This frame has been discontinued by the manufacturer. If you are attempting to place a complete job
                    (Frame + Rx) please contact your Customer Service to make arrangements to send in the frame from
                    your board.
                  </p>
                  <p
                    *ngIf="
                      (frame?.statusCode == 'L_PHASE' || frame?.statusCode == 'L_OE') &&
                      (frame?.exceptionType == 'OUT_OF_STOCK' ||
                        frame?.exceptionType == null ||
                        frame?.exceptionType == 'OK') &&
                      frame?.inStock == false
                    "
                    style="margin-bottom:10px;"
                    class="out-of-stock-class"
                  >
                    This frame has been discontinued by the manufacturer. If you are attempting to place a complete job
                    (Frame + Rx) please contact your Customer Service to make arrangements to send in the frame from
                    your board.
                  </p>
                  <p
                    *ngIf="frame?.exceptionType == 'SHORT_SHIP_NEW'"
                    style="margin-bottom:10px;"
                    class="out-of-stock-class"
                  >
                    New to your assortment and will be sent to you as part of Refresh.
                  </p>
                </div>
                <div class="row" *ngIf="(relatedFrames$ | async).length >= 1">
                  <div class="col s12 mt-10">
                    <p>Available Frame Sizes</p>
                    <div class="radio-group">
                      <mat-radio-group
                        [formControl]="eyeSize"
                        (change)="selectEyeSize()"
                        aria-label="Available Frame Sizes"
                      >
                        <mat-radio-button
                          class="available-frames"
                          name="frameEyeSize"
                          *ngFor="let eyeSize of frameSize"
                          [value]="eyeSize"
                          >{{ eyeSize }}
                          <span *ngIf="frame?.eyeSize != eyeSize">Not available in the selected color.</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
                <hr class="divider mt-20" />
                <div class="row" *ngIf="is360Available">
                  <div class="col s12">
                    <img
                      class="image-360-view"
                      src="/assets/images/icons/icon-360-image.png"
                      height="50"
                      width="100"
                      (click)="open360FrameModal(frame?.upc)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row mt-20">
                <div class="col s12 text-align-right" *ngIf="patientId">
                  <ecp-add-to-cart-btn
                    *ngIf="frame?.collectionContext === 'InModule' && user?.isPremiumMember"
                    [patientId]="patientId"
                    [frameDetail]="frame"
                  ></ecp-add-to-cart-btn>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <!-- Related Frames -->
      <div class="row" *ngIf="(relatedFrames$ | async)?.length > 0">
        <div class="container">
          <div class="row is-flex pt-10">
            <div class="col l3 m4 s6" *ngFor="let frame of relatedFrames$ | async">
              <ecp-related-catalog-frame-item
                class="col s12"
                [title]="frame?.brandName + ' ' + frame?.styleName"
                [name]="frame?.brandName"
                [desc1]="frame?.colorDescription"
                [desc2]="frame?.moduleName"
                [image]="frame?.largeImageUrl"
                [upc]="frame?.upc"
                [selectedFrameUpc]="selectedFrameUpc"
                (onClick)="changeFrame(frame)"
              >
              </ecp-related-catalog-frame-item>
              <!--                <a (click)="changeFrame(frame)">-->
              <!--                  <img src="{{frame?.smallImageUrl}}">-->
              <!--                  <div class="align-center">{{frame?.colorDescription}}</div>-->
              <!--                </a>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 l4 order-frame" *ngIf="patientId === '' && isViewOnly === false">
    <mat-card class="mat-card--widget-order" *ngIf="frame?.isOrderable && user?.program.isOrderable">
      <mat-card-header>
        <mat-card-title>Order Frame</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <!--          <div class="container">-->
        <div style="padding-left: 10px; padding-right: 10px;">
          <form (submit)="onSubmit($event)" [formGroup]="form">
            <!-- Send Frame to -->
            <div class="text">
              <label id="radio-group-label">Send frame to</label>
            </div>
            <div class="radio-group send-frame">
              <mat-radio-group [formControl]="sendFrameTo" aria-label="Send frame to">
                <ng-container *ngIf="orderability === '2' || orderability === '0'">
                <mat-radio-button
                  value="Lab"
                  *ngIf="
                    frame?.inStock === true ||
                    (frame?.exceptionType != 'OUT_OF_STOCK' && frame?.exceptionType != 'SHORT_SHIP')
                  "
                  >Lab</mat-radio-button
                ></ng-container>
                <ng-container  *ngIf="orderability === '1' || orderability === '0'">
                  <mat-radio-button value="My Office" [checked]="orderability==='1'" class="ml-16">My Offices</mat-radio-button>
                </ng-container>
              </mat-radio-group>
            </div>
            <!-- Send -->
            <div class="mt-20">
              <mat-checkbox
                [formControl]="displayBoard"
                *ngIf="sendFrameTo.value == 'My Office'"
                class="mat-checkbox--as-button mt-20"
              >
                This is for my display board
              </mat-checkbox>
            </div>
            <!-- Form -->
            <div
              class="mt-10"
              *ngIf="sendFrameTo.value == 'My Office' && displayBoard.value && frame?.collectionContext === 'InBrand'"
            >
              <p>Would you like to add this frame to your collection?</p>
              <div class="radio-group send-frame">
                <mat-radio-group [formControl]="addFrameTo" aria-label="Add Frame to">
                  <mat-radio-button value="true">Yes</mat-radio-button>
                  <mat-radio-button value="false" class="ml-16">No</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="row mt-20" *ngIf="sendFrameTo.value == 'My Office' && !displayBoard.value">
              <div class="col s12 m6">
                <mat-form-field>
                  <input matInput name="First_Name__c" placeholder="First Name" [formControl]="firstName" required />
                  <mat-error>
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Special characters are not allowed.
                  </mat-error>
                  <mat-error *ngIf="firstName?.errors?.required">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Please enter patient's first name.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col s12 m6">
                <mat-form-field>
                  <input matInput name="Last_Name__c" placeholder="Last Name" [formControl]="lastName" required />
                  <mat-error>
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Special characters are not allowed.
                  </mat-error>
                  <mat-error *ngIf="lastName?.errors?.required">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Please enter patient's last name
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row mt-20" *ngIf="sendFrameTo.value == 'Lab'">
              <div class="col m12 s12">
                <mat-form-field>
                  <mat-select
                    name="laboratory"
                    (selectionChange)="getDropShip()"
                    [formControl]="laboratory"
                    placeholder="Select a laboratory"
                  >
                    <mat-option value="primary" *ngIf="manageCareLabList.primary !== null">{{
                      manageCareLabList.primary?.displayName
                    }}</mat-option>
                    <mat-option value="managed_care">Secondary Laboratory</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="laboratory.value == 'managed_care' && sendFrameTo.value == 'Lab'" class="col m12 s12 mb-20">
                <p>Select a Secondary Laboratory</p>
                <mat-radio-group [formControl]="manageCareLab" name="manageCareLab" aria-label="Send frame to">
                  <mat-radio-button
                    *ngFor="let manageCareLab of manageCareLabList.managedCare"
                    [value]="manageCareLab"
                    class="manage-care-radio mb-10"
                  >
                    {{ manageCareLab.displayName }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col m12 s12" *ngIf="sendFrameTo.value == 'Lab'">
                <mat-form-field>
                  <mat-select
                    name="provider"
                    (selectionChange)="onChange($event)"
                    [formControl]="provider"
                    placeholder="Select a provider type"
                  >
                    <mat-option value="privatepay">PRIVATE PAY</mat-option>
                    <mat-option value="eyemed">EYEMED</mat-option>
                    <mat-option value="uhc">UHC VISION - SPECTERA</mat-option>
                    <mat-option value="vba">VBA</mat-option>
                    <mat-option value="versant">VERSANT</mat-option>
                    <mat-option value="vsp">VSP</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col s12 m6" *ngIf="!displayBoard.value && provider.value !== 'uhc'">
                <mat-form-field>
                  <input matInput name="First_Name__c" placeholder="First Name" [formControl]="firstName" (keyup)="onChangeName('firstName',$event)" required />
                  <mat-error>
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Special characters are not allowed.
                  </mat-error>
                  <mat-error *ngIf="firstName?.errors?.required">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Please enter patient's first name.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col s12 m6" *ngIf="!displayBoard.value && provider.value !== 'uhc'">
                <mat-form-field>
                  <input matInput name="Last_Name__c" placeholder="Last Name" [formControl]="lastName" (keyup)="onChangeName('lastName',$event)" required />
                  <mat-error>
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Special characters are not allowed.
                  </mat-error>
                  <mat-error *ngIf="lastName?.errors?.required">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Please enter patient's last name.
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="sendFrameTo.value == 'Lab'" class="col m12 s12">
                <mat-form-field>
                  <label class="custom--input-label"
                    >RX Order ID
                    <fa-icon class="icon__info" (click)="tooltip.toggle()" icon="info-circle"></fa-icon>
                    <span
                      #tooltip="matTooltip"
                      matTooltip="Your RX order ID is: &#13; &#13; &#8226; Private Pay: Vision Web E-order # (i.e. SP1234AB) or Eyefinity Order # (i.e. Z12345678) &#13; &#8226; Eyemed: Eyemed Claim Number / E-Order Confirmation (i.e. SP1234AB) &#13; &#8226; UHC Vision / Spectera: Spectera Tracking Number (V1234567890123) &#13; &#8226; VBA: VBA Rx Order # (i.e. 1234567890) &#13; &#8226;  Versant: Versant Order Confirmation (i.e. SP1234AB) &#13; &#8226; VSP: Eyefinity Lab Order / Benefit Number (i.e. 12345678) &#13;
                              Not providing a valid RX Order ID will delay delivery time"
                      matTooltipClass="multiline-tooltip"
                      matTooltipPosition="above"
                    ></span>
                  </label>
                  <input matInput name="rxOrderId" [formControl]="rxOrderId" (change)="onChange($event)" />
                  <mat-error *ngIf="!isVBA && rxOrderId?.errors?.required && !rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    Please enter a valid RX ID.
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'privatepay' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid Private Pay / VisionWeb RX : SP followed by 6 alphanumeric
                    characters (i.e. SP1234AB) or Eyefinity Order # (i.e. Z12345678).
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'eyemed' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid Eyemed RX: SP followed by 6 alphanumeric characters (i.e.
                    SP1234AB).
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'uhc' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid UHC Spectara RX: V followed by exactly 13 alphanumeric
                    characters.
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'vba' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid Vision Benefit Association RX: Exactly 10 numbers (i.e.
                    1234567890)
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'versant' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid Versant RX: SP followed by 6 alphanumeric characters (i.e.
                    SP1UF1WF)
                  </mat-error>
                  <mat-error *ngIf="provider.value === 'vsp' && rxOrderId?.errors">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                    The format of the RX ID is invalid. Valid VSP RX: Exactly 8 numbers (i.e. 12345678)
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mt-10">
              <ng-container *ngIf="isDtpEnabled() && user?.featureFlag === 1">
                <div class="col s12 m12">
                  <div class="mb-10">
                    <mat-checkbox [(ngModel)]="showAddressToggle" (change)="showPatient($event)" [ngModelOptions]="{ standalone: true }">
                      Ship To Patient
                    </mat-checkbox>
                  </div>
                </div>
                <hr />
                <ng-container *ngIf="showAddressToggle">
                  <div class="col m6 s12">
                    <mat-form-field>
                      <input matInput name="_firstName" formControlName="_firstName" placeholder="First Name" />
                    </mat-form-field>
                  </div>
                  <div class="col m6 s12">
                    <mat-form-field>
                      <input matInput name="_lastName" formControlName="_lastName" placeholder="Last Name" />
                    </mat-form-field>
                  </div>
                  <div class="col m4">
                    <mat-form-field>
                      <input matInput name="_number" formControlName="_number" placeholder="Number" />
                    </mat-form-field>
                  </div>
                  <div class="col m8">
                    <mat-form-field>
                      <input matInput name="_street" formControlName="_street" placeholder="Street" />
                    </mat-form-field>
                  </div>
                  <div class="col s12">
                    <mat-form-field>
                      <input matInput name="_unit" formControlName="_unit" placeholder="Unit / Apartment" />
                    </mat-form-field>
                  </div>
                  <div class="col s12 m6">
                    <mat-form-field>
                      <input matInput name="_city" formControlName="_city" placeholder="City">
                    </mat-form-field>
                  </div>
                  <div class="col s12 m6">
                    <mat-form-field>
                      <mat-select name="_state" formControlName="_state" placeholder="State">
                        <ng-container *ngFor="let codes of stateCodes">
                          <mat-option [value]="codes.value">{{codes.value +' - '+codes.name}}</mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col s12 m6">
                    <mat-form-field>
                      <input matInput name="_zip" formControlName="_zip" placeholder="ZIP/ Postal Code" />
                    </mat-form-field>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <ng-container *ngIf="sendFrameTo.value == 'Lab' && (frame?.isMetaFrame || frame?.isNuanceFrame);">
              <div class="row mt-20">
                <div class="col m12 s12" *ngIf="user?.program.programKey!=='KPLR' else keplr">
                  <p *ngIf="frame?.isMetaFrame && isMeta === false" class="out-of-stock-class">
                    This is a Meta frame. The lab you have selected is not enabled to process Meta
                    frames. Please select a lab that supports Meta orders or reach out to your field consultant to have a Meta enabled lab activated.
                  </p>
                  <p *ngIf="frame?.isNuanceFrame && isNuance === false" class="out-of-stock-class">
                    This is a Nuance frame. The lab you have selected is not enabled to process Nuance
                    frames. Please select a lab that supports Nuance orders or reach out to your field consultant to have a Nuance enabled lab activated.
                  </p>
                </div>
                <ng-template #keplr>
                  <div class="col m12 s12">
                    <p *ngIf="frame?.isMetaFrame && isMeta === false" class="out-of-stock-class">
                      Note: Meta frames cannot be ordered as a complete job through this portal. Orders can only be placed for plano frames to be shipped directly to your practice.
                    </p>
                    <p *ngIf="frame?.isNuanceFrame && isNuance === false" class="out-of-stock-class">
                      Note: Nuance frames cannot be ordered as a complete job through this portal. Orders can only be placed for plano frames to be shipped directly to your practice.
                    </p>
                  </div>
                </ng-template>
              </div>
            </ng-container>
            <ng-template #showOtherMessage>
              <div class="row mt-20">
                <div class="col m12 s12">
                  <p
                    *ngIf="
                      (frame?.statusCode == 'L_ACTIVE' &&
                        frame?.exceptionType == 'OUT_OF_STOCK' &&
                        frame?.inStock == false) ||
                      (frame?.exceptionType == 'SHORT_SHIP' && frame?.inStock == false)
                    "
                    class="out-of-stock-class"
                  >
                    Out of stock for an extended period of time. Complete job orders are not available..
                  </p>
                  <p
                    *ngIf="frame?.statusCode == 'L_ACTIVE' && frame?.exceptionType === null && frame?.inStock == false"
                    class="out-of-stock-class"
                  >
                    Temporary Out Of Stock. More frames are on the way, but orders for this frame may suffer some delay.
                  </p>
                </div>
              </div>
            </ng-template>
            <!-- <div *ngIf="RBAMessage !== ''">
              <p style="font-weight: bold;">{{ RBAMessage }}</p>
            </div> -->
            <div class="btn-group--fill">
              <button
                class="btn btn-primary mt-30"
                [disabled]="isOrderFrameDisabled()"
                type="submit"
              >
                Order Frame
                <fa-icon *ngIf="loading$ | async" icon="spinner" [spin]="true"></fa-icon>
              </button>
            </div>
          </form>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
